import React from "react"
import { IoIosArrowRoundForward } from "react-icons/io"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Welcome = () => {
  const data = useStaticQuery(graphql`
    query ImageQuery {
      file(relativePath: {eq: "VictorCropped.png"}) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <section className="grid grid-cols-12 max-h-1/2">
      <div data-aos="slide-right" data-aos-duration="800" className="lg:col-span-6 col-span-12">
        <Img fluid={data.file.childImageSharp.fluid} />
      </div>
      <div data-aos="slide-left" data-aos-duration="800" className="lg:col-span-6 col-span-12 border-2 border-gray-200">
        <div className="p-5">
          <h4 className="text-2xl p-4 mt-10 tracking-wider">BIENVENIDO A NUESTRA CLÍNICA!</h4>
          <p className="mt-6 text-2xl font-light pl-4 tracking-wide text-main_color">Somos una unidad médica conformada por especialistas que atienden las necesidades de la población.</p>
          <p className="mt-6 text-lg font-thin pl-4">Nuestras mayores áreas de especialización son Dermatología Médica, Quirúrgica y Estética, Medicina Fotónica y Estética</p>
          <div className="flex mt-10 items-center">
            <p className="font-medium pl-4">CONOCE NUESTRA HISTORIA</p>
            <IoIosArrowRoundForward className="text-2xl" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Welcome